/*
* Configuration for Checkout
*/
export default function () {
  return {
    greetingVideoEnable: false
  }
}
